import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Layout, Menu, Badge } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faColumns,
  faUsers,
  faTicketAlt,
  faUserMd,
  faClock,
  faDatabase,
  faQrcode,
  faBell,
  faFolder,
} from "@fortawesome/free-solid-svg-icons";

import useGetTodaysQueueInfo from "../../../Hooks/queries/useGetTodaysQueueInfo";
import useGetTodaysOnlineQueueInfo from "../../../Hooks/queries/useGetTodaysOnlineQueueInfo";
import useGetPendingCertificate from "@Hooks/queries/useGetPendingCertificate";
import "./AdminSidebar.css";

const { Sider } = Layout;
const { SubMenu } = Menu;

const AdminSidebar = ({ collapsed, location }) => {
  const { data: todaysQueueInfo, isLoading: isLoadingTodaysQueueInfo } = useGetTodaysQueueInfo();
  const { data: todaysOnlineQueueInfo, isLoading: isLoadingTodaysOnlineQueueInfo } = useGetTodaysOnlineQueueInfo();
  const { data: dataPendingCertificate, isLoading: isLoadingPendingCertificate } = useGetPendingCertificate();

  const isHaveTodaysQueueInfo = !isLoadingTodaysQueueInfo && todaysQueueInfo?.shift?.id !== null;
  const isHaveTodaysOnlineQueueInfo = !isLoadingTodaysOnlineQueueInfo && todaysOnlineQueueInfo?.shift?.id !== null;

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      className="custom-sider"
      width={320}
      collapsedWidth={80}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'sticky',
        top: 0,
        left: 0,
        flexShrink: 0
      }}
    >
      <div className="logo-container">
        {!collapsed ? (
          <h1 className="adm-sidebar-title">
            KLINIK <br />
            PEDIATRICA <br />
            HUSADA
          </h1>
        ) : (
          <h1 className="adm-sidebar-title-collapsed">
            KPH
          </h1>
        )}
      </div>

      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        defaultOpenKeys={[]}
      >
        <Menu.Item key="/admin-dashboard" icon={<FontAwesomeIcon icon={faColumns} />}>
          <Link to="/admin-dashboard">Dashboard</Link>
        </Menu.Item>

        <Menu.Item key="/patients" icon={<FontAwesomeIcon icon={faUsers} />}>
          <Link to="/patients">Manajemen Anak</Link>
        </Menu.Item>

        <Menu.Item key="/request-certificate" icon={<FontAwesomeIcon icon={faFolder} />}>
          <Link to="/request-certificate">
            Request Sertifikat
            {!isLoadingPendingCertificate && dataPendingCertificate?.count > 0 && (
              <Badge
                count={dataPendingCertificate.count}
                size="small"
                style={{ border: "none", fontWeight: "bold", marginLeft: 8 }}
              />
            )}
          </Link>
        </Menu.Item>

        <Menu.Item
          key="/duplicate-data"
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: 14, height: 14 }}>
              <path d="M7.5 3.375c0-1.036.84-1.875 1.875-1.875h.375a3.75 3.75 0 013.75 3.75v1.875C13.5 8.161 14.34 9 15.375 9h1.875A3.75 3.75 0 0121 12.75v3.375C21 17.16 20.16 18 19.125 18h-9.75A1.875 1.875 0 017.5 16.125V3.375z" />
              <path d="M15 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0017.25 7.5h-1.875A.375.375 0 0115 7.125V5.25zM4.875 6H6v10.125A3.375 3.375 0 009.375 19.5H16.5v1.125c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625V7.875C3 6.839 3.84 6 4.875 6z" />
            </svg>
          }
        >
          <Link to="/duplicate-data">Data Duplikat</Link>
        </Menu.Item>

        <SubMenu key="sub-queue" icon={<FontAwesomeIcon icon={faTicketAlt} />} title="Manajemen Antrian">
          <Menu.Item key="/queue-practicing-doctor">
            <Link to="/queue-practicing-doctor">Praktek</Link>
          </Menu.Item>
          <Menu.Item key="/queue-online-consultation">
            <Link to="/queue-online-consultation">Konsultasi Online</Link>
          </Menu.Item>
        </SubMenu>

        <Menu.Item key="/users" icon={<FontAwesomeIcon icon={faUserMd} />}>
          <Link to="/users">Manajemen Perawat</Link>
        </Menu.Item>

        <Menu.Item key="/vaccination-schedule" icon={<FontAwesomeIcon icon={faClock} />}>
          <Link to="/vaccination-schedule">Jadwal Vaksinasi</Link>
        </Menu.Item>

        <Menu.Item key="/visits" icon={<FontAwesomeIcon icon={faClock} />}>
          <Link to="/visits">Jadwal Kunjungan</Link>
        </Menu.Item>

        <SubMenu key="sub-notif" icon={<FontAwesomeIcon icon={faBell} />} title="Notifikasi">
          <Menu.Item key="/context">
            <Link to="/context">Konteks</Link>
          </Menu.Item>
          <Menu.Item key="/broadcast">
            <Link to="/broadcast">Broadcast</Link>
          </Menu.Item>
          <Menu.Item key="/notifications">
            <Link to="/notifications">Notifikasi</Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu key="sub-master" icon={<FontAwesomeIcon icon={faDatabase} />} title="Master Data">
          <Menu.Item key="/vaccines">
            <Link to="/vaccines">Daftar Vaksin</Link>
          </Menu.Item>
          <Menu.Item key="/vaccine-types">
            <Link to="/vaccine-types">Tipe Vaksin</Link>
          </Menu.Item>
          <Menu.Item key="/shifts">
            <Link to="/shifts">Shift</Link>
          </Menu.Item>
          <Menu.Item key="/blocked-dates">
            <Link to="/blocked-dates">Blocked Dates</Link>
          </Menu.Item>
          <Menu.Item key="/blocked-dates-online">
            <Link to="/blocked-dates?shift_type=konsultasi_online">Blocked Dates Online</Link>
          </Menu.Item>
          <Menu.Item key="/bank-accounts">
            <Link to="/bank-accounts">Rekening Bank</Link>
          </Menu.Item>
          <Menu.Item key="/terms-and-conditions">
            <Link to="/terms-and-conditions">Syarat &amp; Ketentuan</Link>
          </Menu.Item>
          <Menu.Item key="/configuration">
            <Link to="/configuration">Konfigurasi</Link>
          </Menu.Item>
          <Menu.Item key="/otp-login-pasien">
            <Link to="/otp-login-pasien">OTP Login Pasien</Link>
          </Menu.Item>
        </SubMenu>

        <Menu.Item key="online-queue" icon={<FontAwesomeIcon icon={faTicketAlt} />}>
          {isHaveTodaysOnlineQueueInfo ? (
            <Link to={`/queues-online/${todaysOnlineQueueInfo?.shift?.id}`}>Antrian Konsultasi Online</Link>
          ) : (
            <Link to="/queues-front-online/show-admin">Antrian Konsultasi Online</Link>
          )}
        </Menu.Item>

        <Menu.Item key="clinic-queue" icon={<FontAwesomeIcon icon={faTicketAlt} />}>
          {isHaveTodaysQueueInfo ? (
            <Link to={`/queues/${todaysQueueInfo?.shift?.id}`}>Antrian Klinik</Link>
          ) : (
            <Link to="/queues-front/show-admin">Antrian Klinik</Link>
          )}
        </Menu.Item>

        <Menu.Item key="show-clinic-queue" icon={<FontAwesomeIcon icon={faTicketAlt} />}>
          {isHaveTodaysQueueInfo ? (
            <a href={`/show-queues/${todaysQueueInfo?.shift?.id}`} target="_blank" rel="noopener noreferrer">
              Tampilkan Antrian Klinik
            </a>
          ) : (
            <a href="/queues-front/show-public" target="_blank" rel="noopener noreferrer">
              Tampilkan Antrian
            </a>
          )}
        </Menu.Item>

        <Menu.Item key="qrcode" icon={<FontAwesomeIcon icon={faQrcode} />}>
          <a href="/qrcode" target="_blank" rel="noopener noreferrer">QR Code</a>
        </Menu.Item>

        <Menu.Item key="scan-barcode" icon={<FontAwesomeIcon icon={faQrcode} />}>
          <a href="/running-queue" target="_blank" rel="noopener noreferrer">Scan Barcode</a>
        </Menu.Item>

        <Menu.Item key="self-checkin" icon={<FontAwesomeIcon icon={faQrcode} />}>
          <Link to="/self-checkin">Self Checkin</Link>
        </Menu.Item>

      </Menu>
    </Sider>
  );
};

export default withRouter(AdminSidebar);
